import { inject } from '@angular/core';
import { type CanActivateFn, Router } from '@angular/router';

/** Bare `/projects/new` (hand-typed URL) has no project and no create in flight — a photo pick there
 *  would be dropped. Send it through the cabinet's own entry: the settings step creates the project. */
export const projectWizardEntryGuard: CanActivateFn = route =>
  !!route.queryParamMap.get('projectId') || route.queryParamMap.get('creating') === '1'
    ? true
    : inject(Router).createUrlTree(['/projects/new'], { queryParams: { creating: 1 } });
